import { common } from './common.icons';

export const IconGrid5 = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 24 21"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-grid5 ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
    >
      <rect width="4" height="4" transform="translate(0 16.1665)" />
      <rect width="4" height="4" transform="translate(7 16.1665)" />
      <rect width="4" height="4" transform="translate(14 16.1665)" />
      <rect width="17" height="12" transform="translate(0 0.166504)" />
      <rect width="4" height="4" transform="translate(20 0.166504)" />
      <rect width="4" height="4" transform="translate(20 8.1665)" />
      <rect width="4" height="4" transform="translate(20 16.1665)" />
    </svg>
  );
};
